import { ConstantinePorthole, ConstantineSleeping } from "@octopus-energy/coral/media"

function isNightTime(): boolean {
    const hour = new Date().getHours()

    return hour >= 20 || hour < 6
}

export function ConstantineAmbient() {
    return isNightTime() ? <ConstantineSleeping /> : <ConstantinePorthole />
}
